<script setup lang="ts">
  import Typography from '../Typography/Typography.vue'
  import type { ContentAttributionProps } from './types'

  withDefaults(defineProps<ContentAttributionProps>(), {
    sourceIconUrl: '',
    time: '',
    classes: 'text-content-secondary',
  })
</script>

<template>
  <div class="w-full shrink-0">
    <div class="flex items-center gap-1 truncate" :class="classes">
      <img
        v-if="sourceIconUrl"
        :src="sourceIconUrl"
        alt=""
        aria-hidden="true"
        class="h-4 w-4 rounded-sm object-contain"
        loading="lazy"
      />
      <Typography element="span" variant="text-xs" classes="truncate">
        {{ sourceName }}
      </Typography>
      <Typography
        v-if="sourceName && time"
        element="span"
        variant="text-xs"
        classes="shrink-0"
      >
        &middot;
      </Typography>
      <Typography
        v-if="time"
        element="span"
        variant="text-xs"
        classes="shrink-0"
      >
        {{ time }}
      </Typography>
    </div>
  </div>
</template>
